import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonContent, IonPopover, IonCol, IonIcon, IonImg, IonText } from '@ionic/react';
import { copyOutline, settingsOutline } from 'ionicons/icons';
import { FC, useRef, useState } from 'react';
import { translation } from '../models/translation';

interface CampaingCardProps {
    title: string,
    id: string,
    edit?: any,
    imageUrl?: string,
    reason: string,
    navigate: any,
    status: any

}

const CampaignCardEdit: FC<CampaingCardProps> = ({ title, id, imageUrl, reason, navigate, status }) => {

    const siteText = translation()
    const lan = siteText.lan.replace("/", "")
    const popover = useRef<HTMLIonPopoverElement>(null);
    const [copyPopoverOpen, setCopyPopoverOpen] = useState(false);
    const [copiedUrl, setCopiedUrl] = useState<any>({})

    const urlToClipBoard = async (e: any, url: string) => {
        popover.current!.event = e;
        try {
            // Write the text to the clipboard
            setCopiedUrl({ text: `${siteText.fundraiserUrlCopyWorked}`, message: url, error: false })
            await navigator.clipboard.writeText(url).then(m => setCopyPopoverOpen(true))
        } catch (err) {
            setCopiedUrl({ text: `${siteText.fundraiserUrlCopyErr}`, message: err, error: true });
            setCopyPopoverOpen(true)
        }
    }

    return (

        <IonCol sizeXs='12' sizeSm='6' sizeMd='4'>
            <IonCard type="button" button>
                <IonCardHeader>
                    <div className="img16by9-container">
                    <IonImg src={imageUrl ? imageUrl : process.env.PUBLIC_URL + '/assets/placeholder_image.jpg'}></IonImg>
                    </div>
                    <IonCardTitle>{title}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                    <p dangerouslySetInnerHTML={{ __html: `${reason.substring(0, 96)}...` }}></p>

                    {!status &&
                        <IonButton size='small' fill='solid' style={{ float: 'right' }} color='light' onClick={e => navigate(id, true)} >
                            <IonIcon icon={settingsOutline} slot="icon-only" />
                        </IonButton>
                    }

                    {status && <IonText color='success' style={{ float: 'right' }}>*{siteText.fundraiseCompletedTxt}</IonText>}
                    <IonButton fill='outline' size='small' onClick={e => navigate(id)}>{siteText.detailsBtnTxt}</IonButton>
                    <IonButton size='small' fill='clear' color='dark' onClick={e => urlToClipBoard(e, `https://swissdonations.ch/${lan}/fundraisers/${id}`)} >
                        <IonIcon icon={copyOutline} slot="start" /> Url
                    </IonButton>
                    <IonPopover ref={popover} isOpen={copyPopoverOpen} onDidDismiss={() => setCopyPopoverOpen(false)}>
                        <IonContent class="ion-padding">
                            {!copiedUrl.error &&
                                <>
                                    <p><IonText>{copiedUrl.text}</IonText></p>
                                    <p><IonText color='success'>{copiedUrl.message}</IonText></p>
                                </>
                            }
                            {copiedUrl.error &&
                                <>
                                    <p><IonText>{copiedUrl.message}</IonText></p>
                                    <p><IonText color='danger'>{copiedUrl.text}</IonText></p>
                                </>

                            }

                        </IonContent>
                    </IonPopover>
                </IonCardContent>

            </IonCard>
        </IonCol>

    )
}

export default CampaignCardEdit;